/* eslint-disable no-use-before-define,no-restricted-globals */
import React from 'react'

export const useTrackPage = (name) => {
    React.useEffect(() => {
        location.hash = name
    }, [name])
}

export const trackPage = useTrackPage

export const track = (name, property) => {
    try {
        global.heap.track(name, property)
    } catch(e) {
    }
}
